import moment from "moment";
import React, { Component } from "react";
import { optionsStatus, roleId, urls } from "../../constants/app";
import request from "../../action/utils/request";
import swal from 'sweetalert';
import { connect } from "react-redux";
import { setFiscalDataOrder, updateOrderFromTable, sendOrderToFrontpad, setBlockFiscal } from "../../action/orders";
import { fromStore } from "../../selectors";
import { pingExtension, requestAtol } from "../../action/cassa";
import Select from 'react-select';
import { fetchCategories, fetchGoods, fetchRaw, setActiveModalAction, updateInvoice } from "../../action";
import { withRouter } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import { ReceiptOrder } from "./ReceiptOrder";
import CourierSelector from "../utils/CourierSelector";
import FrontPadIcon from '../icons/FrontPadIcon';
import { isEmpty, throttle } from "lodash";
import { getGoodWithReceipeData } from "../../action/recipes";
import { comparisonVersionExtension, parseNumToFixed } from "../../utils/common";
import { fetchPayments } from "../../action/handbook";
import { getCookie } from "../../utils/cookie";

const сashTitle = {
    no: 'Под расчет',
    c1000: 'Сдача с 1000',
    c1500: 'Сдача с 1500',
    c2000: 'Сдача с 2000',
    c5000: 'Сдача с 5000',
};

const courierStatuses = {
    accepted: 'Принял заказ',
    arrived_to_source: 'Прибыл на место',
    taken: 'Взял заказ',
    arrived_to_destination: 'Прибыл к клиенту',
    finished: 'Заказ доставлен',
}

const robovoiceStatuses = {
    no: 'Robovoice: Ожидает отправления на подтверждение',
    successfulSentRequest: 'Robovoice: На подтверждении',
    successfulSentRequestWithEmptyResponse: 'Robovoice: Пустой ответ',
    unsuccessfulSentRequest: 'Robovoice: Ошибка при отправлении запроса',
    successfulCallMade: 'Robovoice: Подтверждено',
    unsuccessfulCallMade: 'Robovoice: Требуется подтверждение оператором',
    redirectToPointCC: 'Robovoice cron: Переведён на КЦ'
};

const payments = [
    {label: 'Наличные', value: 'cash'},
    {label: 'Терминал', value: 'terminal'},
    {label: 'Яндекс', value: 'YE'},
    {label: 'Деливери', value: 'DC'},
];

class OrderRow extends Component {
    constructor(props) {
        super(props);
        this.throttledFiscalization = throttle(
            this.handleFiscalizationOrder.bind(this),
            500,
            { leading: true, trailing: false }
        );
        this.state = {
          showDetails: !['done', 'written-off', 'cancel'].includes(this.props.order.status),
          showChangeStatusLog: false,
          openClient: false,
          openUpDropDownStatusLog: false,
          sendingToFrontpad: false,
          showFiscalButton: false,
          showRefundButton: false,
        };
    }

    ChangeStatusLogRef = React.createRef();

    async componentDidMount(){
        document.addEventListener('mousedown', this.handleClickOutside);
        try {
            if (isEmpty(this.props.categories)) this.props.fetchCategories();
            if (isEmpty(this.props.goodsList)) this.props.fetchGoods();
            await this.updateFiscalButtons(this.props.order);
            if (isEmpty(this.props.payments)) fetchPayments(true);
            this.props.payments.forEach((payment) => {
                const isDuplicate = payments.some(item => item.value === payment.Name);
                if (!isDuplicate) {
                    if (payment.value !== null && payment.value !== 'none' && payment.value !== 'online') payments.push({ label: payment.VisibleName, value: payment.Name });
                }
            });

        } catch (err) {
            console.error(err);
        }
    }

    async componentDidUpdate(prevProps) {
        try {
            if (prevProps.order !== this.props.order) await this.updateFiscalButtons(this.props.order);
        } catch (err) {
            console.error(err);
        }
    }

    renderFiscalButton = async (order) => {
        if (![roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id)) return false;
        if (order.workingShiftId) return true;
        const workingShift = await this.getWorkingShift(order, true) || null;
        if (!workingShift) return false;
        return true;
    }

    renderRefundButton = async (order) => {
        if (![roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id)) return false;
        if (!order.workingShiftId) return false;
        if (!order.fiscalized) return false;
        const params = { 'id': order.workingShiftId };
        const workingShift = await request({ method: 'get', url: urls.workingShift, params });
        if (workingShift && workingShift[0]) return workingShift[0].closed_at ? true : false;
        return false;
    }

    updateFiscalButtons = async (order) => {
        const showFiscal = await this.renderFiscalButton(order);
        const showRefund = await this.renderRefundButton(order);
        this.setState({ showFiscalButton: showFiscal, showRefundButton: showRefund });
    }
    
    componentWillUnmount(){
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    toggleChangeStatusLog = () => (event) =>  {
        event.stopPropagation();
        this.setState({openUpDropDownStatusLog: window.innerHeight - event.clientY < 340})
        this.setState({ showChangeStatusLog: !this.state.showChangeStatusLog })
    }

    toggleDetails() { this.setState({showDetails: !this.state.showDetails }); }

    handleClickCopy = (text) => () => { navigator.clipboard.writeText(text); }

    renderConsumptionBlockText = (isConsumption, consumptionStatus) => {
        if (consumptionStatus === 'processing') return {
            title: 'Идет учет товаров',
            text: 'Немного подождите и обновите список заказов',
        }

        if (consumptionStatus === 'processingReturn') return {
            title: 'Идет возврат сырья',
            text: 'Немного подождите и обновите список заказов',
        }
        
        if (consumptionStatus === 'done') return {
            title: 'Товары из заказа учтены',
            text: 'Изменение заказа невозможно. Чтобы изменить заказ - измените его статус на "Приготовлен"'
        }

        if (isConsumption) return {
            title: 'Товары из заказа учтены',
            text: 'Изменение заказа невозможно. Чтобы изменить заказ - измените его статус на "Приготовлен"'
        }
    }

    changePoint = async (value, item) => {
        let data = {}
        if ([roleId.courier, roleId.qualityControlManager].includes(this.props.user.role.id)) return null;

        if(item.isConsumption || ['done', 'processing', 'processingReturn'].includes(item.consumptionStatus)) {
            const block = this.renderConsumptionBlockText(item.isConsumption, item.consumptionStatus);
            return swal({
                title: block.title,
                text: block.text,
                icon: "warning",
                button: "Ок",
            });
        }

        if(item.workingShiftId) {
            const workingShift = await request({ method: 'get', url: `${urls.workingShift}/${item.workingShiftId}` });
            if(workingShift && workingShift.closed_at) {
                return swal({
                    title: "Смена закрыта",
                    text: "Изменение заказа невозможно",
                    icon: "warning",
                    button: "Ок",
                });
            }
        }

        if(item.fiscalized) {
            return swal({
                title: "Заказ фискализирован",
                text: "Изменение заказа невозможно",
                icon: "warning",
                button: "Ок",
            });
        }

        if(!value)
            data = {
                point: null,
                workingShiftId: null,
                zone: null,  
            };

        if(value) {
            const renderLogAdress = (city, point) => {
                if(!city && !point) return 'Не определен'
                return `${city ? city.name : point ? point.city.name : 'Город не определен'}${point ? `, ${point.street} ${point.house}` : ', филиал не определен'}`
            }
            const date = new Date();
            const city = this.props.filials.find((el) => el.id === value).city;
            let checkChangeLog = {};
            let log = item.changeLog;

            if(log) {
                if(typeof log === 'string') {
                    checkChangeLog = JSON.parse(log);
                } else {
                    checkChangeLog = log;
                }
            }

            const point = this.getPoint(item);

            const newPoint = this.props.filials.find((el) => el.id === value);

            const workingShift = await this.getWorkingShift(item, false, newPoint) || null;
            const workingShiftId = workingShift && workingShift.id ? workingShift.id : null;
            
            let changeLog = {point: `Филиал изменен с ${renderLogAdress(item.city, point)} на ${renderLogAdress(city, newPoint)}`}
            const logName = String(this.props.user.username + '_' + moment(date).format('DD.MM.YYYY') + '_' + (checkChangeLog ? Object.keys(checkChangeLog).length : 0));

            const username = this.props.user.name ? this.props.user.name : this.props.user.username;
            const roleDescription = this.props.user.role && this.props.user.role.description ? this.props.user.role.description : ''
            const userText = `${username} ${roleDescription}`;

            checkChangeLog[logName] = {
                user: userText,
                date: moment(date).format('DD.MM.YYYY HH:mm:ss'),
                oldPoint: point ? point.id ? point.id : point : null,
                newPoint: newPoint ? newPoint.id ? newPoint.id : newPoint : null,
                ...changeLog
            }
            
            data = {
                city: city,
                point: newPoint,
                workingShiftId: workingShiftId,
                zone: null,
                changeLog: checkChangeLog,
                timeZone: city.timeZone || '+03',
            };

            if (item.isConsumption && (!newPoint.enableConsumption || !this.props.settings.enableConsumption)) {
                data.isConsumption = false;
                data.consumptionStatus = null;
            };
        }


        this.props.updateOrderFromTable(item.id, data, this.props.isArchive, [roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.role) );   
    }

    getGoodsWithGTIN = (goods) => {
        const { goodsList } = this.props;
        if (!goods || goods.length === 0) return null;
        if (!goodsList || goodsList.length === 0) return null;

        return goods.map((good) => {
            const entity = goodsList.find((item) => item.id === +good.id);
            if (!entity) return good;

            if (entity && entity.marked && entity.typeMarked === 'horeca') return { ...good, typeMarked: entity.typeMarked, gtin: entity.gtin};
            return good;
        });
    }

    getMarkedGoods = (goods) => {
        const { goodsList } = this.props;
        if (!goods || goods.length === 0) return null;
        if (!goodsList || goodsList.length === 0) return null;
    
        const markedGoodsList = goodsList.filter((good) => good.marked && (!good.typeMarked || good.typeMarked === 'markingCode')).map((good) => good.id);
        if (!markedGoodsList || markedGoodsList.length === 0) return null;
    
        const result = goods.filter((good) => {
            if (!markedGoodsList.includes(+good.id)) return false;
            const markedCount = good.markedCodes ? good.count - good.markedCodes.length : good.count;
            if (!good.markedCodes || markedCount > 0) return true;
            return false;
        })
        .flatMap((good) => {
            const markedCount = good.markedCodes ? good.count - good.markedCodes.length : good.count;
            if (good.count > 1 && markedCount > 0) {
                return Array.from({ length: markedCount }, () => ({
                    ...good,
                    count: 1
                }));
            }
            return [good];
        });
    
        return (result && result.length > 0) ? result : null;
    }

    getMarkedChar = (good) => {
        if (good.markedCodes && good.markedCodes.length === good.count) return '[М+]';

        const { goodsList } = this.props;
        if (!good) return null;
        if (!goodsList || goodsList.length === 0) return null;

        const goodByList = goodsList.find((item) => item.id === good.id);
        if (goodByList && goodByList.marked) {
            if (!good.markedCodes || good.markedCodes.length === 0) return '[М-]'
            return '[М+-]';
        }
        return null;
    }

    autoAddShift = (visible_datetime) => {
        if (visible_datetime == null) return true;
        if (moment(visible_datetime).isValid() && moment(visible_datetime).isSame(moment(), 'day')) return true;
        return false;
    }

    getPoint = (item) => {
        let point = null;

        if (item.point) {
            if (!item.point.id) {
                point = this.props.filials.find((el) => el.id === item.point);
            } else if (item.point.id) {
                point = item.point;
            }
        } 

        if (!point && item.zone) {
            if (item.zone.point) {
                if (!item.zone.point.id) {
                    point = this.props.filials.find((el) => el.id === item.zone.point);
                } else if (item.zone.point.id) {
                    point = item.zone.point;
                }
            }
        }

        return point;
    }

    changeStatus = async (e, item) => {
        if(item.status !== e.value) {
            if(![roleId.admin, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id) && item.workingShiftId) {
                const workingShift = await request({ method: 'get', url: `${urls.workingShift}/${item.workingShiftId}` });
                if(workingShift && workingShift.closed_at) {
                    return swal({
                        title: "Смена закрыта",
                        text: "Изменение заказа невозможно",
                        icon: "warning",
                        button: "Ок",
                    });
                }
            }

            const data = {
                status: e.value,
                visibleClientStatus: e.client ? e.client : e.label,
                ignoreConsumption: true,
            };

            let checkChangeStatusLog = null

            if(item.changeStatusLog) {
                if(typeof item.changeStatusLog === 'string') {
                    checkChangeStatusLog = JSON.parse(item.changeStatusLog)
                } else {
                    checkChangeStatusLog = item.changeStatusLog
                }
            }

            const date = new Date();
            const logName = String(e.value + '-' + (checkChangeStatusLog ? Object.keys(checkChangeStatusLog).length : 0) + '__' + moment(date).format('DD.MM.YYYY'));
            const username = this.props.user.name ? this.props.user.name : this.props.user.username;
            const roleDescription = this.props.user.role && this.props.user.role.description ? this.props.user.role.description : ''
            const userText = `${roleDescription} ${username}`;

            data.changeStatusLog = {
                ...checkChangeStatusLog,
                [logName]: {
                    status: e.value,
                    date: moment(date).format('DD.MM.YYYY HH:mm'),
                    user: userText
                }
            }

            if (data.status === 'cancel') {
                if(item.fiscalized && ![roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id)) {
                    return swal({
                        title: "Заказ фискализирован",
                        text: "Отмена заказа невозможна",
                        icon: "warning",
                        button: "Ок",
                    });
                }

                return swal({
                    title: "Изменение статуса заказа",
                    text: "Вы действительно хотите отменить заказ?",
                    icon: "warning",
                    dangerMode: true,
                    buttons: ["Отмена", "Отменить заказ"],
                }).then(async (willDelete) => {
                    if (willDelete) {
                        data.ignoreFiscalized = [roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id)
                        data.changeStatusLog = {
                            ...checkChangeStatusLog,
                            [logName]: {
                                status: e.value,
                                date: moment(date).format('DD.MM.YYYY HH:mm:ss'),
                                user: userText
                            }
                        }
                        if (!item.workingShiftId && this.autoAddShift(item.visible_datetime)) await this.handleAddWorkingShiftId(item);
                        return this.props.updateOrderFromTable(item.id, data, this.props.isArchive );
                    }
                });
            }

            if (data.status === 'written-off') {
                if(item.fiscalized && ![roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id)) {
                    return swal({
                        title: "Заказ фискализирован",
                        text: "Списание заказа невозможно",
                        icon: "warning",
                        button: "Ок",
                    });
                }

                return swal({
                    title: "Изменение статуса заказа",
                    text: "Вы действительно хотите списать заказ?",
                    icon: "warning",
                    dangerMode: true,
                    buttons: ["Отмена", "Списать заказ"],
                }).then(async (willDelete) => {
                    if (willDelete) {
                        data.ignoreFiscalized = [roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id)
                        data.changeStatusLog = {
                            ...checkChangeStatusLog,
                            [logName]: {
                                status: e.value,
                                date: moment(date).format('DD.MM.YYYY HH:mm:ss'),
                                user: userText
                            }
                        }
                        if (!item.workingShiftId && this.autoAddShift(item.visible_datetime)) await this.handleAddWorkingShiftId(item)
                        return this.props.updateOrderFromTable(item.id, data, this.props.isArchive );
                    }
                });
            }

            if (data.status === 'cooked') {
                const markedGoods = this.getMarkedGoods(item.goods);
                if (markedGoods && markedGoods.length > 0) {
                    const point = this.getPoint(item);

                    return this.props.setActiveModalAction({ field: 'markedGoods', value: { markedGoods, id: item.id, changeStatus: true, pointId: (point && point.id) ? point.id : null, categories: this.props.categories, isArchive: this.props.isArchive } });
                }
            }

            if (data.status === 'done') {
                const markedGoods = this.getMarkedGoods(item.goods);
                const goodsWithMarkedCodes = item.goods.filter((item) => item.markedCodes && item.markedCodes.length > 0);

                if (markedGoods || goodsWithMarkedCodes) {
                    const point = this.getPoint(item);

                    if (markedGoods) return swal({
                        title: "Отсканированы не все маркированные товары",
                        text: "Выполнение заказа невозможно. Отсканируйте марикрованные товары.",
                        icon: "warning",
                        buttons: ["Отмена","Сканировать товары"],
                    }).then((scan) => {
                        if (scan) return this.props.setActiveModalAction({ field: 'markedGoods', value: { markedGoods, id: item.id, changeStatus: true, pointId: (point && point.id) ? point.id : null, categories: this.props.categories, isArchive: this.props.isArchive } })
                    });
                
                    /*const result = await this.props.sendReceiptMark(item, point);
                    if (!result) return swal({
                        title: "Ошибка отправки данных в ЧЗ.",
                        text: "Продажа маркированных товаров невозможна",
                        icon: "warning",
                        button: "Ок",
                    });

                    if (result.error) return swal({
                        title: "Ошибка отправки данных в ЧЗ.",
                        text: result.error,
                        icon: "warning",
                        button: "Ок",
                    });*/
                }

                if (isEmpty(item.aggData) || isEmpty(item.aggData.commission)) {
                    const point = this.getPoint(item);
                    
                    if (point.id && ((item.source && !['site', 'crm', 'app'].includes(item.source)) || (!isEmpty(item.aggData) && item.aggData.platform))) {
                        const platform = (!isEmpty(item.aggData) && item.aggData.platform) ? item.aggData.platform : item.source;
                        const entitySource = this.props.platforms.find((source) => source.value === platform);
                        if (entitySource && entitySource.isAggregator && !isEmpty(entitySource.commissions)) {
                            const currentCommission = entitySource.commissions.find((commission) => commission.allPoints || commission.pointsIds.includes(+point.id));
                            if (!isEmpty(currentCommission)) {
                                const currentAggData = { ...(item.aggData || {})};
                                currentAggData.commission = { sum: +currentCommission.sum || 0, sumAgg: +currentCommission.sumAgg || 0, type: currentCommission.type, persent: +currentCommission.persent || 0, persentAgg: +currentCommission.persentAgg || 0 };
                                data.aggData = currentAggData;
                            }
                        }
                    }
                }
                
            }
            
            data.changeStatusLog = {
                ...checkChangeStatusLog,
                [logName]: {
                    status: e.value,
                    date: moment(date).format('DD.MM.YYYY HH:mm:ss'),
                    user: userText
                }
            }

            if (data.status === 'deferred') data.workingShiftId = null;
            if (!['deferred', 'not-confirmed', 'processing', 'new', 'confirmed'].includes(data.status) && !item.workingShiftId && this.autoAddShift(item.visible_datetime)) await this.handleAddWorkingShiftId(item);
            const result = await this.props.updateOrderFromTable(item.id, { ...data, ignoreFiscalized: true }, this.props.isArchive );
            if (result && result.error) return swal({
                title: "Ошибка смены статуса.",
                text: result.error.message || '',
                icon: "error",
                button: "Ок",
            })
        }      
    }

    detachWorkingShift = (id) => {
        const data = { workingShiftId: null, ignoreFiscalized: true, ignoreConsumption: true }
        return this.props.updateOrderFromTable(id, data, this.props.isArchive );
    }
    
    handleClickOutside = (e) => {
        if (e.target.closest(`[data-toggle="status_log_${this.props.order.id}"]`)) return;
        if (this.ChangeStatusLogRef.current && !this.ChangeStatusLogRef.current.contains(e.target)) {
          this.setState({ showChangeStatusLog: false });
        }
    };

    handleDoubleClick = (item) => async () => {
        if (this.props.blockFiscal) return;
        if ([roleId.courier, roleId.qualityControlManager].includes(this.props.user.role.id)) return;

        if(item.isConsumption || ['done', 'processing', 'processingReturn'].includes(item.consumptionStatus)) {
            const block = this.renderConsumptionBlockText(item.isConsumption, item.consumptionStatus);
            return swal({
                title: block.title,
                text: block.text,
                icon: "warning",
                button: "Ок",
            });
        }
        
        if(!this.props.openClient) {
            if(item.workingShiftId) {
                const workingShift = await request({ method: 'get', url: `${urls.workingShift}/${item.workingShiftId}` });
                if(workingShift && workingShift.closed_at) {
                    return swal({
                        title: "Смена закрыта",
                        text: "Изменение заказа невозможно",
                        icon: "warning",
                        button: "Ок",
                    });
                }
            }

            if(item.fiscalized) {
                return swal({
                    title: "Заказ фискализирован",
                    text: "Изменение заказа невозможно",
                    icon: "warning",
                    button: "Ок",
                });
            }

            const url = this.props.isArchive ? '/archive' : '/orders';
            this.props.history.push(`${url}/edit/${+item.id}`)
        }
    }

    testUUID = async (order) => {
        let workingShift = null;
        
        if (order.workingShiftId) workingShift = await request({ method: 'get', url: `${urls.workingShift}/${order.workingShiftId}` });

        let device = null;

        if (workingShift && workingShift.deviceId) {
            device = await request({ method: 'get', url: `${urls.devices}/${workingShift.deviceId}` });
        } else {
            const params = {};
            params['point.id'] = workingShift.point.id;
            const devices = await request({ method: 'get', url: `${urls.devices}`, params });
            device = devices[0];
        }

        if (!device || !device.id) {
            return swal({
                title: "Не обнаружено устройство подключенное к филиалу",
                text: "Запрос состояния заказа невозможен",
                icon: "warning",
                button: "Ок",
            });
        }

        const requestData = {
            fiscalUUID: order.fiscalUUID,
            type: 'getTaskResult',
            host: device.host ? device.host : "http://127.0.0.1",
            port: device.port ? device.port : "16732",
            login: device.login,
            password: device.password,
        }
        const fiscalization = await this.props.requestAtol(requestData);

        const renderText = () => {
            if (!fiscalization) return 'Данные не получены'
            let result = [];
            if (fiscalization.error) return `Ошибка выполнения запроса состояния: Код ошибки: ${fiscalization.error.code}, ${fiscalization.error.description}`

            fiscalization.results.map((item) => {
                if (item.error && item.error.code && item.error.code > 0) return result.push(`Код ошибки: ${item.error.code ? item.error.code : 'NaN'}, ${item.error.description ? item.error.description : ''}, status: ${item.status ? item.status : 'NaN'}.`);
                if (item.result && item.result.fiscalParams) return result.push('Данные успешно отправлены и приняты ккт.');
                return null
            });

            return result.join(' | ');
        }

        return swal({
            title: "Состояние в ФН",
            text: renderText(),
            button: "Ок",
        });
    }

    openChangeLog = (order) => {
        this.props.setActiveModalAction({ field: 'changeLogOrder', value: order });
    }

    handleRefundOrder = async (order) => {
        if (!order.payment || !['cash', 'terminal'].includes(order.payment)) return swal({
            title: "Возврат заказа не возможен",
            text: 'Фискализация доступна только для способов оплаты "Наличные" и "Терминал"',
            icon: "warning",
            button: "Ок",
        });

        const orderPoint = this.renderSelectPoint(order);
        if (!orderPoint || !orderPoint.value) return swal({
            title: "Возврат заказа не возможен",
            text: 'Филал не определен',
            icon: "warning",
            button: "Ок",
        });
        
        const params = {
            'point.id': parseInt(orderPoint.value),
            closed_at_null: true,
        }
        const workingShiftsPoint = await request({ method: 'get', url: urls.workingShift, params });
        const workingShift = workingShiftsPoint ? workingShiftsPoint[0] : null;
        if (!workingShift) return swal({
            title: "Открытая смена не найдена.",
            text: "Возврат заказа не возможен. Откройте смену и повторите попытку.",
            icon: "warning",
            button: "Ок",
        });

        let device = null;

        if (workingShift.deviceId) {
            device = await request({ method: 'get', url: `${urls.devices}/${workingShift.deviceId}` });
        } else {
            const params = {};
            params['point.id'] = workingShift.point.id;
            const devices = await request({ method: 'get', url: `${urls.devices}`, params });
            device = devices[0];
        }

        if (!device || !device.id) {
            this.props.setActiveModalAction({ field: 'loaderKKTModal', value: false });
            return swal({
                title: "Не обнаружено устройство подключенное к филиалу",
                text: "Фискализация заказа невозможна, обратитесь к администратору",
                icon: "warning",
                button: "Ок",
            });
        }

        const dataPoint = this.props.filials.find((item) => item.id === parseInt(orderPoint.value))

        this.props.setActiveModalAction({ field: 'refundOrderModal', value: { device, order, workingShift: workingShift.id, point: dataPoint }});
    }

    handleFiscalizationOrder = async (order, ignoreMarkedCodes) => {
        if (this.props.blockFiscal && !ignoreMarkedCodes) return;
        this.props.setBlockFiscal(true);

        try {
            const result = await this.fiscalizationOrder(order, ignoreMarkedCodes);
            return result;
        } finally {
            this.props.setBlockFiscal(false);
        }
    };

    fiscalizationOrder = async (order, ignoreMarkedCodes) => {
        if (!order.payment || !['cash', 'terminal'].includes(order.payment)) return swal({
            title: "Фискализация заказа невозможна",
            text: 'Фискализация доступна только для способов оплаты "Наличные" и "Терминал"',
            icon: "error",
            button: "Ок",
        });

        if (![roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id) && !order.fiscalized && ['written-off', 'cancel'].includes(order.status)) {
            return swal({
                title: "Фискализация заказа невозможна",
                text: 'Заказ отменен или списан. Для фискализации измените статус.',
                icon: "error",
                button: "Ок",
            });
        }

        let checkChangeLog = {};
        let log = order.changeLog;
        const date = new Date();

        if(log) {
            if(typeof log === 'string') {
                checkChangeLog = JSON.parse(log);
            } else {
                checkChangeLog = log;
            }
        }

        let changeLog = {fiscalized: order.fiscalized ? 'Иницирована попытка снятия фискализации' : 'Иницирована попытка фискализации'}
        const logName = String(this.props.user.username + '_' + moment(date).format('DD.MM.YYYY') + '_' + (checkChangeLog ? Object.keys(checkChangeLog).length : 0));

        const username = this.props.user.name ? this.props.user.name : this.props.user.username;
        const roleDescription = this.props.user.role && this.props.user.role.description ? this.props.user.role.description : ''
        const userText = `${username} ${roleDescription}`;

        checkChangeLog[logName] = {
            user: userText,
            date: moment(date).format('DD.MM.YYYY HH:mm:ss'),
            ...changeLog
        }

        const data = {
            ignoreFiscalized: true,
            changeLog: checkChangeLog,
            ignoreConsumption: true,
        };

        this.props.updateOrderFromTable(order.id, data, this.props.isArchive, [roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.role) );   

        const ping = await this.props.pingExtension();
        if (!ping) return swal({
            title: "Фискализация заказа невозможна",
            text: '101. Не удалось установить соединение с расширением. Проверьте установлено ли у Вас расширение "CRM.ККТ.Соединение" версии не менее чем 2.2.1 и обновите страницу.',
            icon: "error",
            button: "Ок",
        })
        const versionExtension = ping.version;

        const markedGoods = this.getMarkedGoods(order.goods);
        if (markedGoods && markedGoods.length > 0) {
            let point = null;

            if (order.point) {
                if (!order.point.id) {
                    point = this.props.filials.find((el) => el.id === order.point);
                } else if (order.point.id) {
                    point = order.point;
                }
            } 

            if (!point && order.zone) {
                if (order.zone.point) {
                    if (!order.zone.point.id) {
                        point = this.props.filials.find((el) => el.id === order.zone.point);
                    } else if (order.zone.point.id) {
                        point = order.zone.point;
                    }
                }
            }

            return this.props.setActiveModalAction({ field: 'markedGoods', value: { markedGoods, id: order.id, changeStatus: false, pointId: (point && point.id) ? point.id : null, categories: this.props.categories, isArchive: this.props.isArchive } });
        }

        this.props.setActiveModalAction({ field: 'loaderKKTModal', value: true });

        let workingShift = null;
        let workingShiftId = order.workingShiftId;

        if (!workingShiftId) workingShiftId = await this.handleAddWorkingShiftId(order);
        
        if (workingShiftId) workingShift = await request({ method: 'get', url: `${urls.workingShift}/${workingShiftId}` });
        
        const workingShiftPointId = (workingShift && workingShift.point) ? workingShift.point.id ? workingShift.point.id : workingShift.point : null;
        const orderPoint = this.renderSelectPoint(order);
        let newWorkingShift;

        if (!parseInt(workingShiftPointId) || parseInt(workingShiftPointId) !== parseInt(orderPoint.value)) {
            const params = {
                'point.id': parseInt(orderPoint.value),
                closed_at_null: true,
            }
            const workingShiftsPoint = await request({ method: 'get', url: urls.workingShift, params });
            newWorkingShift = workingShiftsPoint ? workingShiftsPoint[0] : null;
            if (!newWorkingShift) return swal({
                title: "Смена закрыта",
                text: "Фискализация заказа невозможна",
                icon: "warning",
                button: "Ок",
            });
        } else {
            if (!workingShift || workingShift.closed_at) {
                this.props.setActiveModalAction({ field: 'loaderKKTModal', value: false });
                return swal({
                    title: "Смена закрыта",
                    text: "Фискализация заказа невозможна",
                    icon: "error",
                    button: "Ок",
                });
            }
        }

        const resultWorkingShift = newWorkingShift ? newWorkingShift : workingShift;
        let device = null;

        if (resultWorkingShift.deviceId) {
            device = await request({ method: 'get', url: `${urls.devices}/${resultWorkingShift.deviceId}` });
        } else {
            const params = {};
            params['point.id'] = resultWorkingShift.point.id;
            const devices = await request({ method: 'get', url: `${urls.devices}`, params });
            device = devices[0];
        }

        if (!device || !device.id) {
            this.props.setActiveModalAction({ field: 'loaderKKTModal', value: false });
            return swal({
                title: "Не обнаружено устройство подключенное к филиалу",
                text: "Фискализация заказа невозможна, обратитесь к администратору",
                icon: "error",
                button: "Ок",
            });
        }

        order.goods = this.getGoodsWithGTIN(order.goods);

        const requestData = {
            order,
            workingShift: resultWorkingShift,
            ffd: device.ffd || 1.2,
            type: order.fiscalized ? 'sellReturn' : 'sell',
            cashier: device.user || null,
            host: device.host ? device.host : "http://127.0.0.1",
            port: device.port ? device.port : "16732",
            login: device.login,
            password: device.password,
        };

        if (comparisonVersionExtension(versionExtension, '2.3')) {
            const url = this.props.isArchive ? urls.archive : urls.orders;
            requestData.returnData = {
                method: 'put',
                url: `https://sushibox.tech/api${url}/${order.id}`,
                returnUUID: true,
                data: {
                    fiscalized: order.fiscalized ? false : true, 
                },
                headers: {
                    Authorization: `Bearer ${getCookie('auth')}`
                }
            }
            if (newWorkingShift && newWorkingShift.id) requestData.returnData.data.workingShiftId = newWorkingShift.id;
        };

        const fiscalization = await this.props.requestAtol(requestData, false, ignoreMarkedCodes);

        if (!fiscalization) {
            this.props.setActiveModalAction({ field: 'loaderKKTModal', value: false });
            return swal({
                title: "Ошибка фискализации",
                text: 'Неизвестная ошибка',
                icon: "error",
                button: "Ок",
            });
        }

        if (fiscalization.isBlocked) {
            this.props.setActiveModalAction({ field: 'loaderKKTModal', value: false });
            return swal({
                title: "Ошибка фискализации",
                text: 'Операция заблокирована ККТ.',
                icon: "error",
                button: "Ок",
            });
        }

        if (!comparisonVersionExtension(versionExtension, '2.2.2') &&   fiscalization.error && !fiscalization.fiscalUUID && !fiscalization.uuid) {
            this.props.setActiveModalAction({ field: 'loaderKKTModal', value: false });
            return swal({
                title: "Ошибка фискализации",
                text: `${fiscalization.error.code ? `Код ошибки: ${fiscalization.error.code} ` : ''}${fiscalization.error.description || fiscalization.error.message ? `. ${fiscalization.error.description || fiscalization.error.message}` : ''}`,
                icon: "error",
                button: "Ок",
            });
        }

        let getResultFiscalization;

        if (comparisonVersionExtension(versionExtension, '2.2.2')) {
            getResultFiscalization = fiscalization;
        } else {
            const requestTaskResultData = {
                host: device.host || 'http://127.0.0.1',
                port: device.port || 16732,
                login: device.login,
                password: device.password,
                type: 'getTaskResult',
                fiscalUUID: fiscalization.uuid || fiscalization.fiscalUUID,
            }

            getResultFiscalization = await this.props.requestAtol(requestTaskResultData);
        }

        let error;
        if (getResultFiscalization.error) {
            error = getResultFiscalization.error;
        } else if (getResultFiscalization.results && getResultFiscalization.results[0] && getResultFiscalization.results[0].error) {
            error = getResultFiscalization.results[0].error;
        }

        if (error && error.code !== 0) {
            const { code, error_message, message, description, status} = error;
            let text = '';
            if (code) text += String(code);
            if (!code && status) text += String(status);
            if (!code && !status && getResultFiscalization.status) text += String(getResultFiscalization.status);
            if (message) text += `. ${message}`;
            if (error_message) text +=` ${error_message}`;
            if (description) text += ` ${description}`;
            this.props.setActiveModalAction({ field: 'loaderKKTModal', value: false });
            if (text.includes('Некорректный код маркировки') && !ignoreMarkedCodes) {
                return swal({
                    title: "Ошибка фискализации",
                    text: text,
                    icon: "error",
                    dangerMode: true,
                    buttons: ["Ок", "Игнорировать"]
                }).then((ignore) => {
                    if (ignore) {
                        return swal({
                            title: "Игнорирование маркировки",
                            text: "Чек будет передан в ККТ без кодов маркировки. На чеке не будет обозначения [M+]. Вы уверены, что хотите игнорировать отрицательный результат проверки кода маркировки?",
                            icon: "warning",
                            dangerMode: true,
                            buttons: ["Отмена", "Игнорировать"]
                        }).then((willIgnore) => {
                            if (willIgnore) return this.handleFiscalizationOrder(order, true);
                            return null;
                        })
                    }
                });
            }
            return swal({
                title: "Ошибка фискализации",
                text: text,
                icon: "error",
                dangerMode: true,
                button: "Ок"
            });
        }
        
        if (!comparisonVersionExtension(versionExtension, '2.3')) {
            let changeLogSuccess = {fiscalized: order.fiscalized ? 'Выполнено снятие фискализации' : 'Выполнена фискализация'}
            const logNameSuccess = String(this.props.user.username + '_' + moment(date).format('DD.MM.YYYY') + '_' + (checkChangeLog ? Object.keys(checkChangeLog).length : 0));

            const usernameSuccess = this.props.user.name ? this.props.user.name : this.props.user.username;
            const roleDescriptionSuccess = this.props.user.role && this.props.user.role.description ? this.props.user.role.description : ''
            const userTextSuccess = `${usernameSuccess} ${roleDescriptionSuccess}`;

            checkChangeLog[logNameSuccess] = {
                user: userTextSuccess,
                date: moment(date).format('DD.MM.YYYY HH:mm:ss'),
                ...changeLogSuccess
            }
            
            const data = {
                id: order.id,
                fiscalUUID: fiscalization.fiscalUUID || null,
                fiscalized: requestData.type === 'sell' ? true : false,
                changeLog: checkChangeLog,
            };
    
            if (newWorkingShift && newWorkingShift.id) data.workingShiftId = newWorkingShift.id;
            this.props.setFiscalDataOrder(data);
        }
        
        this.props.setActiveModalAction({ field: 'loaderKKTModal', value: false });
        return swal({
            title: requestData.type === 'sell' ? "Заказ фискализирован" : "Фискал снят",
            icon: "success",
            button: "Ок",
        });
        
    }

    handleCorrection = async (order) => {        
        let workingShift = null;

        if (order.workingShiftId) workingShift = await request({ method: 'get', url: `${urls.workingShift}/${order.workingShiftId}` });
        
        if (!workingShift || workingShift.closed_at) {
            return swal({
                title: "Смена закрыта",
                text: "Коррекция заказа невозможна",
                icon: "warning",
                button: "Ок",
            });
        }

        let device = null;

        if (workingShift.deviceId) {
            device = await request({ method: 'get', url: `${urls.devices}/${workingShift.deviceId}` });
        } else {
            const params = {};
            params['point.id'] = workingShift.point.id;
            device = await request({ method: 'get', url: `${urls.devices}`, params });
            device = device[0];
        }

        if (!device || !device.id) {
            return swal({
                title: "Не обнаружено устройство подключенное к филиалу",
                text: "Фискализация заказа невозможна, обратитесь к администратору",
                icon: "warning",
                button: "Ок",
            });
        }

        const requestData = {
            order,
            workingShift,
            ffd: device.ffd || 1.2,
            cashier: device.user || null,
            type: 'sellCorrection',
            host: device.host ? device.host : "http://127.0.0.1",
            port: device.port ? device.port : "16732",
            login: device.login,
            password: device.password,
        }

        this.props.setActiveModalAction({ field: 'correctionModal', value: requestData })
    }
    
    getWorkingShift = async (item, ignoreVisibleDateTime, point) => {
        if (item.visible_datetime && !ignoreVisibleDateTime) return null;
        let dataPoint;
        if (point) {
            dataPoint = point.id ? point.id : point;
        } else {
            dataPoint = this.renderSelectPoint(item).value
        }
        if (!dataPoint) return null;
        
        const params = {
            'closed_at_null': true,
            'point': dataPoint
        };

        const workingShift = await request({ method: 'get', url: urls.workingShift, params });
        return (workingShift && workingShift[0]) ? workingShift[0] : null;
    }

    handleAddWorkingShiftId = async (order) => {
        const workingShift = await this.getWorkingShift(order, true) || null;
        const workingShiftId = workingShift && workingShift.id ? workingShift.id : null;
        
        const data = {
            workingShiftId: workingShiftId,
            ignoreFiscalized: true,
            ignoreConsumption: true,
        };

        this.props.updateOrderFromTable(order.id, data, this.props.isArchive );
        return workingShiftId;
    }

    handlePrintOrder = (order) => {
        const html = ReactDOMServer.renderToStaticMarkup(<ReceiptOrder payment={this.renderPaymentText(order)} order={order} filials={this.props.filials} goodsList={this.props.goodsList} categories={this.props.categories} user={this.props.user}/>);
        const windowName = 'receiptPrint';
        const windowParams = 'width=600, height=600, top=100, left=100';

        const printWindow = window.open('', windowName, windowParams);

        if (!printWindow) {
            return swal({
                            title: 'Браузер заблокировал открытие нового окна',
                            text: 'Разрешите всплывающие окна и повторите попытку',
                            icon: "error",
                            dangerMode: true,
                            button: "Ок",
                        });
        }
        
        const fullHtml = `
            <!DOCTYPE html>
            <html lang="ru">
            <head>
                <meta charset="UTF-8">
                <title>Чек</title>
                <style>
                    @media print {
                        body * {
                            visibility: hidden;
                        }
                        .receipt, .receipt * {
                            visibility: visible;
                        }
                        .receipt {
                            position: absolute;
                            left: 0;
                            top: 0;
                            margin: 0;
                            padding: 0;
                            overflow: visible !important;
                            page-break-after: avoid;
                            break-inside: avoid;
                        }
                    }
                </style>
            </head>
            <body>
                ${html}
            </body>
            </html>
        `;

        printWindow.document.body.innerHTML = fullHtml;
        printWindow.print();
    };

    getStatusPay = (order) => {
        if (!order.paymentId) return 'не оплачен';

        let paymentData = order.paymentData ? JSON.parse(order.paymentData) : null;

        if (!order.paymentData) return 'не оплачен';
        if (paymentData.status === 'pending') return 'ожидает оплаты';
        if (paymentData.status === 'succeeded') return 'оплачен';
        if (paymentData.status === 'refundPending')  return 'выполняется возврат средств';
        if (paymentData.status === 'refund')  return 'возврат средств выполнен';

        if (paymentData.status === 'canceled') {
            if(paymentData.cancellation_details && paymentData.cancellation_details.party) {
                const initiator = paymentData.cancellation_details.party === 'yoo_money' ? 'ЮКасса' : 'участник процесса';
                return `возврат средств отменен, инициатор ${initiator}`;
            }
            return 'возврат средств отменен';
        }

        if (paymentData.error && typeof paymentData.error === 'string') return paymentData.error;

        return 'cтатус не определен';
    }

    renderWok = (good, index) => {
        return (
            <>
            <tr key={index} className='order_table-order-card'>
                <td>{good.wokData.main.title}</td>
                <td style={{ paddingLeft: '5px', width: '25px', textAlign: 'start', color: '#000'}}>{good.count}</td>
                <td style={{ paddingRight: '5px', width: '40px', textAlign: 'end', color: '#000'}}>{good.wokData.main.price}</td>            
            </tr>
            {good.wokData.meat && Object.values(good.wokData.meat).map((el) =>
                <tr key={el.id + index} className='order_table-order-card'>
                    <td className={`order_table-order-card__name${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>{'--' + el.data.title}</td>               
                    <td style={{ paddingLeft: '5px', width: '25px', textAlign: 'start', color: '#000'}}>{el.count}</td>
                    <td style={{ paddingRight: '5px', width: '40px', textAlign: 'end', color: '#000'}}>{el.data.price}</td>
                </tr>
            )}
            {good.wokData.topping && Object.values(good.wokData.topping).map((el) =>
                <tr key={el.id + index} className='order_table-order-card'>
                    <td className={`order_table-order-card__name${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>{'--' + el.data.title}</td>               
                    <td style={{ paddingLeft: '5px', width: '25px', textAlign: 'start', color: '#000'}}>{el.count}</td>
                    <td style={{ paddingRight: '5px', width: '40px', textAlign: 'end', color: '#000'}}>{el.data.price}</td>
                </tr>
            )}
            {good.wokData.souce && Object.values(good.wokData.souce).map((el) =>
                <tr key={el.id + index} className='order_table-order-card'>
                    <td className={`order_table-order-card__name${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>{'--' + el.title}</td>               
                    <td style={{ paddingLeft: '5px', width: '25px', textAlign: 'start', color: '#000'}}>{el.count}</td>
                    <td style={{ paddingRight: '5px', width: '40px', textAlign: 'end', color: '#000'}}>{el.price}</td>                    
                </tr>
            )}
            </>
        );
    }

    renderGoodTitle = (good) => {
        const entityGood = this.props.goodsList.find((g) => parseInt(g.id) === parseInt(good.id));

        let name = '';
        if (entityGood && !isEmpty(entityGood.equipment) && entityGood.equipment.souce) name += `${entityGood.equipment.souce}.`

        if (good.categoryName) {
            if (good.categoryName.toLowerCase() === 'пицца') {
                name += `${good.data.title} ${good.isMod ? '36 см' : '30 см' }`
                return name;
            }
            name += good.data.title
            return name;
        }
        const category = this.props.categories.find(o => o.id === good.category);
        if (!category) return good.data.title;
        if (category.title.toLowerCase() === 'пицца') {
            name += `${good.data.title} ${good.isMod ? '36 см' : '30 см' }`;
            return name;
        }
        name += good.data.title
        return name;
    }

    renderGoods(good, index){
        if (good.isWok) return this.renderWok(good, index);

        return (
            <tr key={index} className='order_table-order-card'>
                <td>
                    <div className={`order_table-order-card__name${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>{good.isPromo ? <span className="badge badge-danger badge-sm ms-2 px-2 py-1" style={{ marginRight: '5px' }}>Промо</span>: ''}{this.renderGoodTitle(good)} {this.getMarkedChar(good)}</div>
                </td>
                <td style={{ paddingLeft: '5px', width: '25px', textAlign: 'start', color: '#000'}}>{good.count}</td>
                <td style={{ paddingRight: '5px', width: '40px', textAlign: 'end', color: '#000'}}>{good.price}</td>                  
            </tr>
        );  
    }

    renderSalePrice(salePrice, bonusCount){
        let saleCheck = 0

        if(salePrice && salePrice > 0) 
            saleCheck = saleCheck + salePrice;
        

        if(bonusCount && bonusCount > 0) 
            saleCheck = saleCheck + bonusCount;
        

        return saleCheck;
    }

    getOrderPointId(item) {
        let pointId;

        if (item.point) {
            if (typeof item.point === 'object' &&  item.point.id) {
                pointId = item.point.id;
            } else {
                pointId = item.point;
            }
        } else if (item.zone && item.zone.point) {
            if (typeof item.zone.point === 'object' &&  item.zone.point.id) {
                pointId = item.zone.point.id;
            } else {
                pointId = item.zone.point;
            }
        }

        return pointId;
    }

    renderSelectPoint(item) {
        if (!item.point && !item.zone) return ({ value: null, label: ''});
        if(item.zone && !item.zone.point.id && !this.props.filials.find((el) => el.id === item.zone.point)) return ({ value: null, label: ''});
        const pointId = this.getOrderPointId(item);
        
        if (!pointId) return ({ value: null, label: ''});
        const entity = this.props.filials.find((fil) => fil.id === pointId);
        if (isEmpty(entity)) return ({ value: null, label: ''});

        const getCityName = () => {
            if (item && item.city && item.city.name) return item.city.name;
            if (entity && entity.city && entity.city.name) return entity.city.name;
            return '-';
        }

        return ({
            value: entity.id,
            label: `${getCityName()}, ${entity.street}, ${entity.house}`
        });         
    }

    getAdress(item, cityTitle, notRenderPoint) {
        if (!item) return null;
        const {
          street, house, room, entrance, floor, area, privateHouse,
        } = item;
        let cityName = cityTitle ? cityTitle : item.city.name;
        if (!cityName && item.deliveryMethod === 'delivery') {
            const pointId = this.getOrderPointId(item);
            if (pointId) {
                const entity = this.props.filials.find((fil) => fil.id === pointId);
                if (!isEmpty(entity)) cityName = entity.city.name;
            }
        }
        if (!street) return null;
        const adress = `${area ? `${area}, ` : ''}${street} ${house}${room ? `, квартира ${room}` : ''}${floor ? `, этаж ${floor}` : ''}${entrance ? `, подъезд ${entrance}` : ''}${privateHouse ? ' (частный дом)' : ''}`;
        const renderCity = !notRenderPoint && cityName && !adress.includes(cityName) ? `${cityName}, ` : '';
        return `${renderCity}${adress}`;
    };

    renderAdress(item) {
        const notRenderPoints = [];
        if (this.props.settings) {
          if (this.props.settings.idPointCC) notRenderPoints.push(this.props.settings.idPointCC);
          if (this.props.settings.idPointRobovoice) notRenderPoints.push(this.props.settings.idPointRobovoice);
        }

        const pointId = (item.point && item.point.id) ? item.point.id : (item.zone && item.zone.point && item.zone.point.id) ? item.zone.point.id : null;

        let notRenderPoint = false;

        if (notRenderPoints && notRenderPoints.length > 0 && pointId) {
          notRenderPoint = notRenderPoints.includes(pointId);
        }
        if (!item.city) return '-';
        if (item.deliveryMethod === 'own' && !notRenderPoint) return this.getAdress(item.point, item.city.name);
        if (item.deliveryMethod === 'own' && !isEmpty(item.hiddenPoint) && notRenderPoint) return this.getAdress(item.hiddenPoint, item.city.name);
        return this.getAdress(item, item.city.name, notRenderPoint);
    };

    renderAggData(item) {
        if (!item.aggData) return null;
        let data = [];
        const deliveryInfo = item.aggData.deliveryInfo;
        const courierInfo = item.aggData.courierInfo;

        if (deliveryInfo) {
            if (deliveryInfo.clientName) data.push(`Клиент: ${deliveryInfo.clientName}`);
            if (deliveryInfo.phoneNumber) data.push(`Телефон клиента: ${deliveryInfo.phoneNumber}`);
            if (deliveryInfo.additionalPhoneNumbers) data.push(`Доп. номер: ${deliveryInfo.additionalPhoneNumbers}`);
            if (deliveryInfo.realPhoneNumber) data.push(`Прямой номер клиента: ${deliveryInfo.realPhoneNumber}`);
            if (deliveryInfo.clientArrivementDate) data.push(`Приготовить к: ${moment(deliveryInfo.clientArrivementDate).format('DD.MM.YYYY HH:mm')}`);
            if (deliveryInfo.deliveryDate) data.push(`Доставить в: ${moment(deliveryInfo.deliveryDate).format('DD.MM.YYYY HH:mm')}`);
            if ((!courierInfo || !courierInfo.maxPlaceArrivalTime) && deliveryInfo.courierArrivementDate) data.push(`Курьер прибудет в: ${moment(deliveryInfo.courierArrivementDate).format('DD.MM.YYYY HH:mm')}`);
        }

        if (courierInfo) {
            if (courierInfo.courier) {
                if (courierInfo.courier.name) data.push(`Курьер: ${courierInfo.courier.name}`);
                if (courierInfo.courier.phone) data.push(`Тел. курьера: ${courierInfo.courier.phone}`);
                if (courierInfo.courier.status) data.push(`Статус курьера: ${courierStatuses[courierInfo.courier.status]}`);
            }
            if (courierInfo.maxPlaceArrivalTime) data.push(`Курьер прибудет в: ${moment(courierInfo.maxPlaceArrivalTime).format('DD.MM.YYYY HH:mm')}`);
        }

        if (data && data.length > 0) return `| Информация агрегатора: ${data.join(', ')}`;
        return null;
    }

    renderPhoneClient(item) {
        if (item.phone) return item.phone;
        if (!item.aggData || !item.aggData.deliveryInfo) return null;
        const deliveryInfo = item.aggData.deliveryInfo;
        if (deliveryInfo.realPhoneNumber) return deliveryInfo.realPhoneNumber;
        if (deliveryInfo.phoneNumber) return deliveryInfo.phoneNumber;
    }

    renderAdressSelect(item){
        return `${item.city ? item.city.name + ', ' : ''}${item.street}, ${item.house}`;
    }

    renderCourier(item) {
        if ([roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector, roleId.courier].includes(this.props.role)) return <CourierSelector isDisabled={this.props.blockFiscal} item={item} openClient={this.props.openClient} isArchive={this.props.isArchive}/>
    }

    renderStatusLabel(status) {
        const result = optionsStatus.find((item) => item.value === status);
        return result || { value: null, label: 'Не определен' };
    }

    filteredStatuses(status, deliveryMethod, point, zone) {
        const role = this.props.user.role.id;
        let currentPoint = null;
        if (point) {
            currentPoint = point;
        } else if (zone) {
            currentPoint = zone.point;
        }
        if (currentPoint && !currentPoint.id) currentPoint = this.props.filials.find((fil) => fil.id === currentPoint);
        if (!currentPoint || !currentPoint.atolData || !currentPoint.atolData.activate) return optionsStatus;

        if (role === roleId.admin) return optionsStatus;
        if (role === roleId.courier) return [optionsStatus.find((item) => item.value === 'done')];

        const canceledStatuses = optionsStatus.filter((item) => ['written-off', 'cancel', 'deferred'].includes(item.value));
        let result = optionsStatus;

        if (['written-off', 'cancel', 'done'].includes(status)) {
            result = result.filter((item) => ['written-off', 'cancel', 'done', 'cooked'].includes(item.value));
            return result;
        }

        if (['new', 'processing', 'not-confirmed', 'confirmed', 'deferred'].includes(status)) {
            result = result.filter((item) => {
                if (['new', 'processing', 'not-confirmed', 'confirmed'].includes(item.value)) return true;
                if ([roleId.cashier, roleId.manager, roleId.regionalDirector, roleId.operationDirector, roleId.admin].includes(role) && item.value === 'cook') return true;
                return false;
            });
            return [...result, ...canceledStatuses];
        }

        if (status === 'cook') {
            result = result.filter((item) => {
                if ([roleId.cashier, roleId.manager, roleId.regionalDirector, roleId.operationDirector, roleId.admin].includes(role) && item.value === 'cooked') return true;
                return false;
            });
            return [...result, ...canceledStatuses];
        }

        if (status === 'cooked' && deliveryMethod === 'delivery') {
            result = result.filter((item) => {
                if (item.value === 'delivery' || item.value === 'cooked') return true;
                if (item.value === 'done') return true;
                return false;
            });   
            return [...result, ...canceledStatuses];
        }

        if ((status === 'cooked' && deliveryMethod === 'own') || status === 'delivery') {
            result = result.filter((item) => {
                if (deliveryMethod === 'own' && item.value === 'cooked') return true;
                if (status === 'delivery' && item.value === 'delivery') return true;
                if (item.value === 'done') return true;
                return false;
            });
            return [...result, ...canceledStatuses];
        }
    }

    renderStatus(item) {
        return <div className='order_table_selector'>
                    <Select
                        isLoading={this.props.loadingFilials || this.props.loadingUpdateorder === item.id}
                        isDisabled={[roleId.qualityControlManager].includes(this.props.user.role.id) || this.props.openClient || (this.props.loadingFilials || this.props.loadingUpdateorder === item.id) || this.props.blockFiscal}
                        value={this.renderStatusLabel(item.status)}
                        closeMenuOnSelect={true}
                        classNamePrefix='order_table_status_select'
                        onChange={(e) => {
                            let paymentData = item.paymentData ? JSON.parse(item.paymentData) : null;
                            if (item.payment === 'online' && (!item.paymentId || !paymentData || paymentData.status !== 'succeeded')) {
                                return swal({
                                    title: "Изменение статуса заказа",
                                    text: "Оплата онлайн - заказ не оплачен. Вы уверены, что хотите изменить статус заказа?",
                                    icon: "warning",
                                    dangerMode: true,
                                    buttons: ["Отмена", "Подтвердить"],
                                }).then(async (ignore) => {
                                    if (ignore) return this.changeStatus(e ? e : null, item);
                                    return null;
                                });
                            };
                            return this.changeStatus(e ? e : null, item);
                        }}
                        styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 })
                        }}
                        menuPlacement="auto"
                        options={this.filteredStatuses(item.status, item.deliveryMethod, item.point, item.zone)}                                     
                        placeholder="Статус"
                        noOptionsMessage={() => 'Статусы не найдены'}
                    />
                </div>
    }

    renderTime(order) {
        const time = parseInt(order.timeZone, 10) || 3;
        const baseOrderDate = order.visible_datetime || order.created_at;
        return moment.utc(baseOrderDate).add(time, 'hours');
    }

    renderStatusLog(order) {
        let checkChangeStatusLog = null;

        if(order.changeStatusLog) {
            if(typeof order.changeStatusLog === 'string') {
                checkChangeStatusLog = JSON.parse(order.changeStatusLog);
            } else {
                checkChangeStatusLog = order.changeStatusLog;
            }

            if (typeof checkChangeStatusLog === 'object' && !Array.isArray(checkChangeStatusLog)) {
                checkChangeStatusLog = Object.values(checkChangeStatusLog);
            }
        }
        
        return (
            <div style={{ position: 'relative' }}>
                <div ref={this.ChangeStatusLogRef} className={`dropdown_body_changeLog${this.state.openUpDropDownStatusLog ? ' up' : ''}`}>
                    {checkChangeStatusLog && checkChangeStatusLog.sort((a, b) => moment(b.date, 'DD.MM.YYYY HH:mm:ss') - moment(a.date, 'DD.MM.YYYY HH:mm:ss')).map((item) => (
                        <div className='dropdown_row_changeLog'>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center'}}>
                                <div className={`status_circle ${item.status}`}></div>
                                <span>{`${item.status ? this.renderStatusLabel(item.status).label : 'Статус недоступен'} ${item.date ? moment(item.date, 'DD.MM.YYYY HH:mm:ss').format('HH:mm:ss DD.MM.YYYY') : 'Дата недоступна'} ${item.user}`}</span>
                            </div> 
                        </div>
                    ))}
                    <div className='dropdown_row_changeLog'>
                        <span>{`Создан ${moment(order.created_at).format('HH:mm DD.MM.YYYY')} ${order.author ? order.author : ''}`}</span>
                    </div>
                </div>
            </div>
        )
    }

    renderPointTime(point, zone) {
        let deliveryTime = 60;
        let samTime = 20;

        if(!point && !zone) return '----';

        if(point) {
            if(point.activate === 'disabledAll')
                return 'СТОП';

            if(point.activate === 'disabledDelivery') {
                deliveryTime = 'СТОП';
            } else {
                deliveryTime = point.minDeliveryTime;
            }

            if(point.activate === 'disabledOwn') {
                samTime = 'СТОП';
            } else {
                samTime = point.minSamTime;
            }

            return `${deliveryTime}/${samTime}`;
        }

        if(zone) {
            if(zone.point.id) {
                if(zone.point.activate === 'disabledAll')
                    return 'СТОП';
    
                if(zone.point.activate === 'disabledDelivery') {
                    deliveryTime = 'СТОП';
                } else {
                    deliveryTime = zone.point.minDeliveryTime;
                }
    
                if(zone.point.activate === 'disabledOwn') {
                    samTime = 'СТОП';
                } else {
                    samTime = zone.point.minSamTime;
                }
    
                return `${deliveryTime}/${samTime}`;
            } else {
                const chekPoint = this.props.filials.find((el) => el.id === zone.point);

                if(chekPoint.activate === 'disabledAll')
                    return 'СТОП';
    
                if(chekPoint.activate === 'disabledDelivery') {
                    deliveryTime = 'СТОП';
                } else {
                    deliveryTime = chekPoint.minDeliveryTime;
                }
    
                if(chekPoint.activate === 'disabledOwn') {
                    samTime = 'СТОП';
                } else {
                    samTime = chekPoint.minSamTime;
                }
    
                return `${deliveryTime}/${samTime}`;
            }
        }

        return 'Не опредлено';
    }

    renderRobovoiceStatus = (status, robovoiceStatus) => {
        if (!robovoiceStatus) return;
        if (this.props.user.role.id === roleId.admin || robovoiceStatus !== 'unsuccessfulCallMade') return <span className='indicator_deliveryMethod' style={ robovoiceStatus === 'successfulCallMade' ? { color: '#01a801', outline: '1px solid #01a801' } : { color: '#f00', outline: '1px solid #f00' } }>{robovoiceStatuses[robovoiceStatus]}</span>
        const renderStatuses = optionsStatus.filter((s) => s.renderRobovoiceStatus);
        if (!renderStatuses || renderStatuses.length === 0) return;
        if (renderStatuses.map((item) => item.value).includes(status)) return <span className='indicator_deliveryMethod' style={ robovoiceStatus === 'successfulCallMade' ? { color: '#01a801', outline: '1px solid #01a801' } : { color: '#f00', outline: '1px solid #f00' } }>{robovoiceStatuses[robovoiceStatus]}</span>
        return;
    }

    renderConsumption = (isConsumption, consumptionStatus) => {
        if (consumptionStatus === 'processing') return <span className="indicator_deliveryMethod load">Списание сырья<span className="loading-dots" /></span>;
        if (consumptionStatus === 'processingReturn') return <span className="indicator_deliveryMethod load">Возврат сырья<span className="loading-dots" /></span>;
        if (consumptionStatus === 'done') return <span className="indicator_deliveryMethod">Сырье списано</span>
        if (consumptionStatus === 'error') return <span className="indicator_deliveryMethod danger">Ошибка списания сырья</span>
        if (consumptionStatus === 'errorReturn') return <span className="indicator_deliveryMethod danger">Ошибка возврата сырья</span>
        if (isConsumption) return <span className="indicator_deliveryMethod">Сырье списано</span>
        return;
    }

    renderTagAgg(aggData) {
        if (isEmpty(aggData) || this.props.loadingSources) return;
        let renderAgg;

        const platform = aggData.platform ? aggData.platform : 'YE';
        const entityPlatform = this.props.platforms.find((source) => source.value === platform);
        if (entityPlatform) renderAgg = entityPlatform.label ? entityPlatform.label : entityPlatform.value;
        if (renderAgg) return <span className='indicator_deliveryMethod'>{renderAgg}</span>;
        return;
    }

    renderTags(item) {
        let renderTagSource = false;
        if (item.source !== 'crm') renderTagSource = item.isSite ? 'Сайт' : 'Приложение';
        if (item.source === 'k-porogu') renderTagSource = 'k-porogu';
        const cronMaxCountSendFrontpad = (this.props.settings && this.props.settings.cronMaxCountSendFrontpad && this.props.settings.cronMaxCountSendFrontpad > 0) ? this.props.settings.cronMaxCountSendFrontpad : 10;
       
        return (
            <>
                <span className='indicator_deliveryMethod'>{item.deliveryMethod === 'own' ? 'Вынос' : 'Доставка'}</span>
                {this.renderConsumption(item.isConsumption, item.consumptionStatus)}
                {renderTagSource && <span className='indicator_deliveryMethod'>{renderTagSource}</span>}                
                {item.isAggPrice && <span className='indicator_deliveryMethod'>Цены агрегаторов</span>}
                {item.tags && item.tags.length > 0 && item.tags.map((tag) => <span className='indicator_deliveryMethod'>{tag.name}</span>)}
                {this.renderRobovoiceStatus(item.status, item.robovoiceStatus)}
                {(item.countSendFrontpad && item.countSendFrontpad >= cronMaxCountSendFrontpad) ? <span className='indicator_deliveryMethod danger'>Ошибка отправки во Frontpad</span> : ''}
            </>
        );
    }

    handleSendToFrontpad = async () => {
        this.setState({ sendingToFrontpad: true });
        
        try {
            const data = { orderId: this.props.order.id };
            await this.props.sendOrderToFrontpad(data);
            
            swal({
                title: 'Успех',
                text: `Данные успешно отправлены в Frontpad`,
                icon: "success",
                button: 'OK'
            });
        } catch (error) {
            swal({
                title: 'Ошибка',
                text: `Ошибка при отправлении данных в Frontpad: ${error && error.data && error.data.message ? error.data.message : 'Неизвестная ошибка'}`,
                icon: 'warning',
                dangerMode: true
            });
        } finally {
            this.setState({ sendingToFrontpad: false });
        }
    }

    changePayment = async (item, e) => {
        const value = e.target.value;
        if (!value) return;

        if(item.workingShiftId) {
            const workingShift = await request({ method: 'get', url: `${urls.workingShift}/${item.workingShiftId}` });
            if(workingShift && workingShift.closed_at) {
                return swal({
                    title: "Смена закрыта",
                    text: "Изменение заказа невозможно",
                    icon: "warning",
                    button: "Ок",
                });
            }
        }

        if(item.fiscalized) {
            return swal({
                title: "Заказ фискализирован",
                text: "Изменение заказа невозможно",
                icon: "warning",
                button: "Ок",
            });
        }

        const oldPaymentTitle = this.props.paymentTitle[item.payment] || item.payment;

        if (value === 'cash') {
            e.stopPropagation();
            return this.props.setActiveModalAction({ field: 'changeCashModal', value: { id: item.id, totalPrice: item.totalPrice, oldPaymentTitle, isArchive: this.props.isArchive, changeLog: item.changeLog }});
        }

        if (item.payment === value) return;
        
        let checkChangeLog = {};
        let log = item.changeLog;
        const date = new Date();

        if(log) {
            if(typeof log === 'string') {
                checkChangeLog = JSON.parse(log);
            } else {
                checkChangeLog = log;
            }
        }

        const newPaymentTitle = this.props.paymentTitle[value] || value;
        let changeLog = {payment: `Способ оплаты изменен с ${oldPaymentTitle} на ${newPaymentTitle}`}
        const logName = String(this.props.user.username + '_' + moment(date).format('DD.MM.YYYY') + '_' + (checkChangeLog ? Object.keys(checkChangeLog).length : 0));

        const username = this.props.user.name ? this.props.user.name : this.props.user.username;
        const roleDescription = this.props.user.role && this.props.user.role.description ? this.props.user.role.description : ''
        const userText = `${username} ${roleDescription}`;

        checkChangeLog[logName] = {
            user: userText,
            date: moment(date).format('DD.MM.YYYY HH:mm:ss'),
            ...changeLog
        }

        const data = {
            ignoreConsumption: true,
            payment: value,
            changeCash: null,
            changeLog: checkChangeLog,
        };

        this.props.updateOrderFromTable(item.id, data, this.props.isArchive, [roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.role) );   
    }

    renderPayment = (item) => {
        const { payment, changeCash } = item;
        
        if (payment === 'online') {
            let style = { color: '#01a801' }
            let paymentData = item.paymentData ? JSON.parse(item.paymentData) : null;
            if (!item.paymentId || !paymentData || paymentData.status !== 'succeeded') style = { color: '#f00' };

            return (
                <span style={style}>
                    {this.renderPaymentText(item)}
                </span>
            );
        }
        let changeTitle;

        if (payment === 'cash') {
            if (changeCash) {
                changeTitle = сashTitle[item.changeCash];
                if (!changeTitle) changeTitle = `Сдача c ${item.changeCash.slice(1)}`;
            }
        }

        const isDisabled = () => {
            if ([roleId.courier, roleId.qualityControlManager].includes(this.props.user.role.id)) return true;
            if (this.props.loadingFilials) return true;
            if (this.props.loadingUpdateorder === item.id) return true;
            if (this.props.openClient) return true;
            if (this.props.blockFiscal) return true;
            return false;
        }

        return (
            <>
                <select disabled={isDisabled()} value={payment} onChange={(e) => this.changePayment(item, e)}  className="form-control" style={{ padding: 0 }}>
                    <option value="" />
                    {
                        payments.map((item, index) => (
                            <option key={index} value={item.value}>{item.label}</option>
                        ))
                    }
                </select>
                {changeTitle && <span style={{ color: '#000', display: 'flex', justifyContent: 'center', fontWeight: 600  }}>{changeTitle}</span>}
            </>
        )
    }

    renderPaymentText = (item) => {
        const { payment, changeCash } = item;
        const paymentTitle = this.props.paymentTitle[payment];
        if (payment === 'online') return `${paymentTitle}, ${this.getStatusPay(item)}`;
        if (payment === 'cash') {
            if (changeCash) {
                let changeTitle = сashTitle[item.changeCash];
                if (!changeTitle) changeTitle = `сдача c ${item.changeCash.slice(1)}`;
                return `${paymentTitle}, ${changeTitle}`;
            }
            return paymentTitle;
        }
        return paymentTitle;
    }

    getChange = (payment, totalPrice, changeCash) => {
        const сashSum = {
            no: null,
            c1000: 1000,
            c1500: 1500,
            c2000: 2000,
            c5000: 5000,
        };
        if (!payment || payment !== 'cash') return null;
        if (!totalPrice) return null;
        if (!changeCash) return <span style={{fontWeight: '600', alignSelf: 'start' }}>Без сдачи</span>
        const sum = сashSum[changeCash] ? сashSum[changeCash] : parseNumToFixed(changeCash.slice(1))
        if (!parseFloat(sum)) return <span style={{ fontWeight: '600', alignSelf: 'start' }}>Без сдачи</span>
        return <span style={{ fontWeight: '600', alignSelf: 'start' }}>{`Сдача ${parseNumToFixed(sum - totalPrice)}`}</span>
    }

    render() {
        const item = this.props.order;
        if(window.innerWidth < 900)
            return (
                <div onDoubleClick={this.handleDoubleClick(item)} className={`kt-datatable__row order_table ${item.status}`} style={{display: 'flex'}}>
                    <div className={`kt-indicator all ${item.status}`}/>
                    <div className='order_table_mobile_main'>
                        <div className='order_table_mobile_head'>
                            <div className='order_table_head'>
                                <div>
                                    <span data-toggle={`status_log_${item.id}`} onClick={this.toggleChangeStatusLog()} style={{ display: 'flex', gap: '5px', alignItems: 'center', borderBottom: '1px dashed #000', cursor: 'pointer'}}>
                                        <span style={(window.innerWidth > 1024 && this.props.openClient) ? { fontSize: '0.9rem' } : {}}>{moment(this.renderTime(item)).format('HH:mm')}</span>
                                        <span style={(window.innerWidth > 1024 && this.props.openClient) ? { fontSize: '0.9rem' } : {}}>{moment(this.renderTime(item)).format('DD.MM.YYYY')}</span>
                                        <span style={(window.innerWidth > 1024 && this.props.openClient) ? { fontSize: '0.9rem' } : {}}>{'№ ' + item.id}</span>
                                    </span>
                                    {this.state.showChangeStatusLog &&
                                        this.renderStatusLog(item)
                                    }
                                </div>
                                <button 
                                className='order_table_arrow-show-details'
                                onDoubleClick={((event) => {
                                    event.stopPropagation()
                                })}   
                                onClick={() => {
                                    this.toggleDetails()
                                }}                   
                                >                 
                                    <i className={`kt-menu__ver-arrow la la-angle-down${this.state.showDetails ? ' Showed' : ''}`}></i>
                                </button>
                                <button className='button_order_table' onClick={this.handleClickCopy(moment(this.renderTime(item)).format('HH:mm') + ' ' + moment(this.renderTime(item)).format('DD.MM.YYYY') + '(№ ' + item.id + ')')}>
                                    <i className='kt-nav__link-icon flaticon2-copy order_table'/>
                                </button>
                                {this.renderTags(item)}
                                {this.renderTagAgg(item.aggData)}
                            </div>
                            <div style={{ minWidth: '120px'}}>
                                {this.renderStatus(item)}
                            </div>
                        </div>
                        <div className='order_table_head' style={{ padding: '5px'}}>
                            <button disabled={this.props.blockFiscal} onClick={this.handleDoubleClick(item)} className="btn_order_head"><i className="flaticon2-contract" style={{ padding: '3px 5px' }}/></button>
                            {this.state.showFiscalButton &&
                                <>
                                {
                                    this.props.blockFiscal 
                                    ? 
                                        <button disabled={true} className="btn_order_head kt-spinner--center kt-spinner--sm kt-spinner--dark kt-spinner" style={{ width: '60px', height: '23px' }}/>
                                    :
                                        <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.handleFiscalizationOrder(item)}>
                                            {!item.fiscalized ? 'Фискал' : 'Снять фискал'}
                                        </button>
                                }
                                </>
                            }
                            {this.state.showRefundButton &&
                                <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.handleRefundOrder(item)}>
                                    Возврат
                                </button>
                            }
                            {item.fiscalized && [roleId.admin, roleId.accountant, roleId.chiefAccountant].includes(this.props.user.role.id) &&
                                <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.handleCorrection(item)}> Коррекция заказа </button>
                            }
                            {[roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id) &&
                                <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.handlePrintOrder(item)}> Печать </button>
                            }
                            {this.props.user.role.id === roleId.admin && item.workingShiftId &&
                            <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.detachWorkingShift(item.id)}>
                                Отвязать от смены
                            </button>
                            }
                            {item.changeLog && 
                                <button className="button_order_table" onClick={() => this.openChangeLog(item)}>
                                    <i className='kt-nav__link-icon flaticon-interface-4 order_table'/>
                                </button>
                            }
                            {/* Добавляем кнопку Frontpad в мобильную версию */}
                            {item.point && [roleId.admin, roleId.manager, roleId.coordinator, roleId.operator, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id) && item.point.isEnableFrontpadForPoint &&
                                <button 
                                    type="button" 
                                    onClick={this.handleSendToFrontpad} 
                                    disabled={this.state.sendingToFrontpad}
                                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                                    aria-label="Отправить в Frontpad"
                                    title="Отправить в Frontpad"
                                >
                                    {this.state.sendingToFrontpad ? (
                                        <span className="kt-spinner kt-spinner--sm kt-spinner--primary"></span>
                                    ) : (
                                        <FrontPadIcon />
                                    )}
                                </button>
                            }
                        </div>
                        <div className='order_table_mobile_head' style={{ padding: '5px' }}>
                            {this.renderCourier(item)}
                        </div>
                        <div className='order_table_mobile_row'>
                            <div className='order_table_mobile positions'>
                            {!this.state.showDetails && <button 
                                className='order_table_button-show-details'
                                onDoubleClick={((event) => {
                                    event.stopPropagation()
                                })}   
                                onClick={() => {
                                    this.toggleDetails()
                                }}
                                >
                                    Показать состав
                                </button>}
                            
                            {
                                this.state.showDetails && 
                                <table style={{width: '100%'}}>
                                    {item.goods.map((good, index) => this.renderGoods(good, index))}           
                                </table>                                   
                            }
                            {
                                this.state.showDetails && item.unit &&
                                <table style={{width: '100%'}}>
                                    <tr className='order_table-order-card' style={{ padding: 0, width: '100%'}}>
                                        <td>
                                            <div className={`order_table-order-card__name${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>Приборы</div>
                                        </td>
                                        <td style={{ paddingLeft: '5px', width: '25px', textAlign: 'start', color: '#000'}}>{item.unit}</td>
                                        <td style={{ paddingRight: '5px', width: '40px', textAlign: 'end', color: '#000'}}>0</td>                     
                                    </tr>
                                </table>
                            }
                            {
                                this.state.showDetails && item.deliveryPrice > 0 &&
                                <table style={{width: '100%'}}>
                                    <tr className='order_table-order-card' style={{ padding: 0, width: '100%'}}>
                                        <td>
                                            <div className={`order_table-order-card__name${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>Доставка</div>
                                        </td>
                                        <td style={{ paddingLeft: '5px', width: '25px', textAlign: 'start', color: '#000'}}></td>
                                        <td style={{ paddingRight: '5px', width: '40px', textAlign: 'end', color: '#000'}}>{item.deliveryPrice}</td>                     
                                    </tr>
                                </table>
                            }
                            </div>
                            <div className="order_table_mobile total_price">
                                <span style={{ color: '#000', display: 'flex', justifyContent: 'center' }}>{item.totalPrice}</span>
                            </div>

                            <div className="order_table_mobile total_price">
                                <span style={{ color: '#000', display: 'flex', justifyContent: 'center' }}>{this.renderSalePrice(parseFloat(item.salePrice), parseFloat(item.bonusCount))}</span>
                            </div>
                        </div>
                        <div className='order_table_mobile_row'>
                            <div className="order_table_mobile payment">
                                {this.renderPayment(item)}
                            </div>
                        </div> 
                        <div className='order_table_mobile_row'>                                
                            <div className='order_table_mobile select_point'>
                                <div className='order_table_selector'>
                                    <Select
                                        isLoading={this.props.loadingFilials || this.props.loadingUpdateorder === item.id}
                                        isDisabled={[roleId.courier, roleId.qualityControlManager].includes(this.props.user.role.id) || this.props.loadingFilials || this.props.loadingUpdateorder === item.id || this.props.openClient || this.props.blockFiscal}
                                        value={this.renderSelectPoint(item)}
                                        closeMenuOnSelect={true}
                                        onChange={(e) => {this.changePoint(e ? e.value : null, item)}}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }) 
                                        }}
                                        menuPlacement="auto"
                                        options={[
                                            { value: null, label: "Не определен", access: [ roleId.admin ] },
                                            ...this.props.filials.map((el) => ({ value: el.id, label: this.renderAdressSelect(el) }))
                                        ].filter((option) => !option.access || option.access.includes(this.props.user.role.id))}                                     
                                        placeholder="Филиал"
                                        noOptionsMessage={() => 'Нет городов'}
                                    />        
                                </div>                            
                            </div>
                            <div className="order_table_mobile point_time">
                                <span style={{ color: '#000', display: 'flex', justifyContent: 'center' }}> {this.renderPointTime(item.point, item.zone)}</span>
                            </div>
                        </div>                                                               
                        <div className='order_table_mobile_row'>
                            <div className='order_table_mobile comment'>
                                <span style={{ width: '100%', display: 'flex', gap: '5px', alignItems: 'center', color: '#000'  }}>
                                    {item.aggData && item.aggData.eatsId ? item.aggData.eatsId + ' ': null}
                                    {this.renderAdress(item)}
                                    {item.internalComment ? ', Комментарий: ' + item.internalComment : ''}
                                    {this.renderAggData(item)}
                                    <button className='button_order_table' onClick={this.handleClickCopy(String((item.city ? item.city.name : '') + (item.area ? ', ' + item.area : '') + (item.street ? ', ' + item.street : '') + (item.house ? ', ' + item.house : '')))}>
                                        <i className='flaticon2-copy order_table'/>
                                    </button>
                                </span>
                                {this.getChange(item.payment, item.totalPrice, item.changeCash)}
                            </div>  
                        </div>
                        <div className='order_table_mobile_row'>
                            <div onDoubleClick={((event) => {event.stopPropagation()})} className="order_table_mobile phone_delete">
                                <span style={{ display: 'flex', gap: '5px', alignItems: 'center', color: '#000', justifyContent: 'center' }}>
                                    {this.renderPhoneClient(item)} 
                                    <button className='button_order_table' onClick={this.handleClickCopy(String(this.renderPhoneClient(item)))}>
                                        <i className='kt-nav__link-icon flaticon2-copy order_table'/>
                                    </button>
                                </span>
                                {[roleId.admin].includes(this.props.user.role.id) &&
                                    <button
                                    disabled={this.props.blockFiscal}
                                    className='button_order_table'
                                    onClick={(() => {
                                        this.props.onDelete(item)
                                    })}
                                    >                                    
                                        <i className='kt-nav__link-icon flaticon2-trash order_table'></i>
                                    </button>                           
                                }
                            </div>
                        </div>
                    </div>
                </div>
            );

        return (
            <tr onDoubleClick={this.handleDoubleClick(item)} key={item.id} className={`kt-datatable__row order_table ${item.status}`}>
                <thead style={{ borderBottom: '1px solid #f2f3f8' }}>
                    <th className={`kt-indicator top ${item.status}`}></th>
                    <th 
                    onDoubleClick={((event) => {
                        event.stopPropagation();
                    })}
                    >
                        <div className='order_table_head'>
                            <div style={{ position: 'absolute', display: 'flex', gap: '5px', alignItems: 'center'}}>
                                <div>
                                    <span 
                                    data-toggle={`status_log_${item.id}`}
                                    style={{ display: 'flex', gap: '5px', alignItems: 'center', borderBottom: '1px dashed #000', cursor: 'pointer'}}
                                    onClick={this.toggleChangeStatusLog()}
                                    >
                                        <span style={(window.innerWidth > 1024 && this.props.openClient) ? { fontSize: '0.9rem' } : {}}>{moment(this.renderTime(item)).format('HH:mm')}</span>
                                        <span style={(window.innerWidth > 1024 && this.props.openClient) ? { fontSize: '0.9rem' } : {}}>{moment(this.renderTime(item)).format('DD.MM.YYYY')}</span>
                                        <span style={(window.innerWidth > 1024 && this.props.openClient) ? { fontSize: '0.9rem' } : {}}>{'№ ' + item.id}</span>
                                    </span>
                                    {this.state.showChangeStatusLog &&
                                        this.renderStatusLog(item)
                                    }
                                </div>
                                <button 
                                className='order_table_arrow-show-details'
                                onDoubleClick={((event) => {
                                    event.stopPropagation()
                                })}   
                                onClick={() => {
                                    this.toggleDetails()
                                }}                   
                                >                 
                                    <i className={`kt-menu__ver-arrow la la-angle-down${this.state.showDetails ? ' Showed' : ''}`}></i>
                                </button>
                                <button className='button_order_table' onClick={this.handleClickCopy(moment(this.renderTime(item)).format('HH:mm') + ' ' + moment(this.renderTime(item)).format('DD.MM.YYYY') + '(№ ' + item.id + ')')}>
                                    <i className='kt-nav__link-icon flaticon2-copy order_table'/>
                                </button>
                                <button disabled={this.props.blockFiscal} onClick={this.handleDoubleClick(item)} className="btn_order_head" style={{ padding: '3px 5px' }}><i className="flaticon2-contract" /></button>
                                {this.state.showFiscalButton &&
                                    <>
                                    {
                                        this.props.blockFiscal 
                                        ? 
                                            <button disabled={true} className="btn_order_head kt-spinner--center kt-spinner--sm kt-spinner--dark kt-spinner" style={{ width: '60px', height: '23px' }}/>
                                        :
                                            <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.handleFiscalizationOrder(item)}>
                                                {!item.fiscalized ? 'Фискал' : 'Снять фискал'}
                                            </button>
                                    }
                                    </>
                                }
                                {this.state.showRefundButton &&
                                    <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.handleRefundOrder(item)}>
                                        Возврат
                                    </button>
                                }
                                {item.fiscalized && [roleId.admin, roleId.accountant, roleId.chiefAccountant].includes(this.props.user.role.id) &&
                                    <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.handleCorrection(item)}> Коррекция заказа </button>
                                }
                                {[roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id) &&
                                    <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.handlePrintOrder(item)}> Печать </button>
                                }
                                {this.props.user.role.id === roleId.admin && item.workingShiftId &&
                                <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.detachWorkingShift(item.id)}>
                                    Отвязать от смены
                                </button>
                                }
                                {item.fiscalUUID && [roleId.admin].includes(this.props.user.role.id) &&
                                <button disabled={this.props.blockFiscal} className='btn_order_head' onClick={() => this.testUUID(item)}>
                                    Состояние
                                </button>
                                }
                                {item.changeLog && 
                                    <button className="button_order_table" onClick={() => this.openChangeLog(item)}>
                                        <i className='kt-nav__link-icon flaticon-interface-4 order_table'/>
                                    </button>
                                }
                                {this.renderTags(item)}
                                {this.renderTagAgg(item.aggData)}
                            </div>
                        </div>                  
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {!(window.innerWidth > 1024 && this.props.openClient) && <th></th>}
                    <th></th>
                    <th style={{ display: 'flex', justifyContent: 'end' }}>{(window.innerWidth > 1024 && this.props.openClient) ? (window.innerWidth <= 1190 && window.innerWidth > 1024) && this.renderStatus(item) : this.renderCourier(item)}</th>
                    {(!(window.innerWidth > 1024 && this.props.openClient) || (window.innerWidth > 1190 || window.innerWidth <= 1024))&& <th>{this.renderStatus(item)}</th>}
                    {/* Добавляем колонку для кнопки Frontpad */}
                    <th>
                        {item.point && [roleId.admin, roleId.manager, roleId.coordinator, roleId.operator, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.user.role.id) && item.point.isEnableFrontpadForPoint &&
                            <button 
                                type="button" 
                                onClick={this.handleSendToFrontpad} 
                                disabled={this.state.sendingToFrontpad}
                                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                                aria-label="Отправить в Frontpad"
                                title="Отправить в Frontpad"
                            >
                                {this.state.sendingToFrontpad ? (
                                    <span className="kt-spinner kt-spinner--sm kt-spinner--primary"></span>
                                ) : (
                                    <FrontPadIcon />
                                )}
                            </button>
                        }
                    </th>
                </thead>

                <tr>
                    <td className={`kt-indicator bottom ${item.status}`}></td>  
                    <td className={`kt-datatable__cell order_table positions${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>
                        {!this.state.showDetails && <button 
                        className='order_table_button-show-details'
                        onDoubleClick={((event) => {
                            event.stopPropagation()
                        })}   
                        onClick={() => {
                            this.toggleDetails()
                        }}
                        >
                            Показать состав
                        </button>}
                    
                    {
                        this.state.showDetails && 
                        <table>
                            {item.goods.map((good, index) => this.renderGoods(good, index))}           
                        </table>                                   
                    }
                    {
                        this.state.showDetails && item.unit &&
                        <tr className='order_table-order-card'>
                            <td>
                                <div className={`order_table-order-card__name${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>Приборы</div>
                            </td>
                            <td style={{ paddingLeft: '5px', width: '25px', textAlign: 'start', color: '#000'}}>{item.unit}</td>
                            <td style={{ paddingRight: '5px', width: '40px', textAlign: 'end', color: '#000'}}>0</td>                     
                        </tr>
                    }
                    {
                        this.state.showDetails && item.deliveryPrice > 0 &&
                        <tr className='order_table-order-card'>
                            <td>
                                <div className={`order_table-order-card__name${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>Доставка</div>
                            </td>
                            <td style={{ paddingLeft: '5px', width: '25px', textAlign: 'start', color: '#000'}}></td>
                            <td style={{ paddingRight: '5px', width: '40px', textAlign: 'end', color: '#000'}}>{item.deliveryPrice}</td>                     
                        </tr>
                    }
                </td>

                <td className={`kt-datatable__cell order_table total_price${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>
                    <span style={{ color: '#000', display: 'flex', justifyContent: 'center' }}>{item.totalPrice}</span>
                </td>

                <td className={`kt-datatable__cell order_table total_price${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>
                    <span style={{ color: '#000', display: 'flex', justifyContent: 'center' }}>{this.renderSalePrice(parseFloat(item.salePrice), parseFloat(item.bonusCount))}</span>
                </td>

                <td className={`kt-datatable__cell order_table payment${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>
                    {this.renderPayment(item)}
                </td>


                
                {!(window.innerWidth > 1024 && this.props.openClient) && <td className='kt-datatable__cell order_table point_time'>
                    <span style={{ color: '#000', display: 'flex', justifyContent: 'center' }}> {this.renderPointTime(item.point, item.zone)}</span>
                </td>}

                <td className={`kt-datatable__cell order_table select_point${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>
                    <div className='order_table_selector'>
                        <Select
                            isLoading={this.props.loadingFilials || this.props.loadingUpdateorder === item.id}
                            isDisabled={[roleId.courier, roleId.qualityControlManager].includes(this.props.user.role.id) || this.props.loadingFilials || this.props.loadingUpdateorder === item.id || this.props.openClient || this.props.blockFiscal}
                            value={this.renderSelectPoint(item)}
                            closeMenuOnSelect={true}
                            onChange={(e) => {this.changePoint(e ? e.value : null, item)}}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }) 
                                }}
                            menuPlacement="auto"
                            options={[
                                { value: null, label: "Не определен", access: [ roleId.admin ] },
                                ...this.props.filials.map((el) => ({ value: el.id, label: this.renderAdressSelect(el) }))
                            ].filter((option) => !option.access || option.access.includes(this.props.user.role.id))}
                            placeholder="Филиал"
                            noOptionsMessage={() => 'Нет городов'}
                        />                                    
                    </div>
                </td>
                    
                <td className={`kt-datatable__cell order_table comment${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>
                    <span style={{ width: '100%', display: 'flex', gap: '5px', alignItems: 'center', color: '#000'  }}>
                        {item.aggData && item.aggData.eatsId ? item.aggData.eatsId + ' ': null}
                        {this.renderAdress(item)}
                        {item.internalComment ? ', Комментарий: ' + item.internalComment : ''}
                        {this.renderAggData(item)}
                        <button className='button_order_table' onClick={this.handleClickCopy(String((item.city ? item.city.name : '') + (item.area ? ', ' + item.area : '') + (item.street ? ', ' + item.street : '') + (item.house ? ', ' + item.house : '')))}>
                            <i className='flaticon2-copy order_table'/>
                        </button>
                    </span>
                    {this.getChange(item.payment, item.totalPrice, item.changeCash)}
                </td>  

                {(!(window.innerWidth > 1024 && this.props.openClient) || (window.innerWidth > 1190 || window.innerWidth <= 1024)) && <td onDoubleClick={((event) => {event.stopPropagation()})} className={`kt-datatable__cell order_table phone${(window.innerWidth > 1024 && this.props.openClient) ? ' openClient' : ''}`}>
                    <span style={{ display: 'flex', gap: '5px', alignItems: 'center', color: '#000', justifyContent: 'center' }}>
                        {this.renderPhoneClient(item)}
                        <button className='button_order_table' onClick={this.handleClickCopy(String(this.renderPhoneClient(item)))}>
                            <i className='kt-nav__link-icon flaticon2-copy order_table'/>
                        </button>
                    </span>
                </td>}

                {[roleId.admin].includes(this.props.user.role.id) &&
                <td className="kt-datatable__cell order_table action">
                    <button
                    disabled={this.props.blockFiscal}
                    className='button_order_table'
                    onClick={(() => {
                        this.props.onDelete(item)
                    })}
                    >                                    
                        <i className='kt-nav__link-icon flaticon2-trash order_table'></i>
                    </button>                           
                </td>
                }
                </tr>                            
            </tr>
        )
    }
}

const mapStateToProps = state => ({
    filials: state.handbook.filials,
    user: state.user.info,
    loadingUpdateorder: state.loaders.updateorder,
    loadingFilials: state.loaders.filials,
    categories: fromStore.categoryListSelector(state),
    role: state.user.info.role.id,
    settings: state.settings.init,
    goodsList: state.good.list,
    loadingSources: state.loaders.sources,
    payments: state.handbook.payments,
    blockFiscal: state.orders.blockFiscal,
});

const mapDispatchToProps = {
    updateOrderFromTable: (id, data, isArchive, getCouriers) => updateOrderFromTable(id, data, isArchive, getCouriers),
    requestAtol: (data, withoutLoader, ignoreMarkedCodes) => requestAtol(data, withoutLoader,  ignoreMarkedCodes),
    //sendReceiptMark: (order, point) => sendReceiptMark(order, point),
    setActiveModalAction: (value) => setActiveModalAction(value),
    setFiscalDataOrder: (data) => setFiscalDataOrder(data),
    sendOrderToFrontpad: (data) => sendOrderToFrontpad(data),
    fetchCategories: () => fetchCategories(),
    fetchGoods: () => fetchGoods(),
    fetchPayments: (isGetAll) => fetchPayments(isGetAll),
    getGoodWithReceipeData: (good, getActualReceipe, dateActualReceipe) => getGoodWithReceipeData(good, getActualReceipe, dateActualReceipe),
    updateInvoice: (id, data) => updateInvoice(id, data),
    pingExtension: () => pingExtension(),
    setBlockFiscal: (value) => setBlockFiscal(value),
    fetchRaw: (id) => fetchRaw(id, true),
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OrderRow));